/* eslint-disable custom-rules/modal-and-drawer-requires-title */
import { useMediaQuery } from '@uhg-abyss/web/hooks/useMediaQuery';
import { Drawer } from '@uhg-abyss/web/ui/Drawer';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { Popover } from '@uhg-abyss/web/ui/Popover';
import { Text } from '@uhg-abyss/web/ui/Text';
import find from 'lodash/find';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useLagoon } from '../../hooks/useLagoon';
import { ConstantsLagoon } from '../ConstantsLagoon';
import { phoneOnly } from '../ConstantsStyles';
import {
  distanceInfoIconText,
  distancePopover,
  drawerStyle,
} from '../RadioGroup/DistanceInfoIcon.styled';

const hcbsPopover = {
  ...distancePopover,
  'abyss-popover-content': {
    boxShadow: '0px 6px 8px -2px #00000029',
    minWidth: '200px',
    maxWidth: '560px',
  },
  'abyss-popover-content-container p': {
    color: '#4B4D4F',
    fontWeight: '400',
    lineHeight: '140%',
  },
};

export const HcbsServicesInfoIcon = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();
  const mobileScreen = useMediaQuery(phoneOnly);

  const data = useLagoon('ui-messaging')();
  const hcbsFilterContent = find(data, {
    key: ConstantsLagoon.UI_MESSAGING.HCBS_INFO_CONTENT,
  });

  const popOverContent: string = hcbsFilterContent?.message || '';
  const popOverTitle: string = hcbsFilterContent?.title || '';

  const content = () => (
    <Flex
      alignItems="center"
      css={{ paddingTop: '12px' }}
      data-auto-testid="hcbs-services-info-icon-button"
      data-testid="hcbs-services-info-icon-button"
      onClick={() => setIsOpen(true)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          setIsOpen(true);
        }
      }}
    >
      <IconSymbol
        aria-hidden="true"
        data-testid="hcbs-services-info-icon"
        focusable="false"
        icon="info"
        size={18}
        variant="outlined"
      />
      <div style={{ marginLeft: '4px' }} />
      <Text
        css={{
          ...distanceInfoIconText,
          'abyss-text-root': {
            ...distanceInfoIconText['abyss-text-root'],
            borderBottom: '1.5px',
          },
        }}
        data-testid="hcbs-services-info-icon-text"
      >
        {t('CONTENT_FILTERS.ALL_FILTERS_DRAWER.HCBS_SERVICES_INFO_LINK')}
      </Text>
    </Flex>
  );

  return (
    <React.Fragment>
      {!mobileScreen ? (
        <Popover
          content={popOverContent}
          css={hcbsPopover}
          data-testid="hcbs-services-info-icon-popover"
          onOpenChange={() => {
            setIsOpen(!isOpen);
          }}
          open={isOpen}
          position="bottom"
          title={popOverTitle}
          width={318}
        >
          {content()}
        </Popover>
      ) : (
        <React.Fragment>
          {content()}
          <Drawer
            css={drawerStyle}
            data-auto-testid="hcbs-services-info-icon-popover"
            data-testid="hcbs-services-info-icon-popover"
            header={popOverTitle}
            isOpen={isOpen}
            onClose={() => setIsOpen(false)}
            position="right"
          >
            <div>{popOverContent}</div>
          </Drawer>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};
